import { BASE_URL } from 'const';

const videosRepositoryV1 = {
  getVideo: (id: string): string =>
    `${BASE_URL}/not-secure/api/v1/videos/${id}`,
};

export default videosRepositoryV1;
